/*
 * @Author: Teemo Ding
 * @Date: 2021-06-28 13:56:01
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 14:56:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelInvoice/InvoiceFormat/index.tsx
 */

import { Input, Radio } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const InvoiceFormat = ({ disableEdit }: { disableEdit?: boolean }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const IDPrefix = [
    {
      label: getI18n('salesChannelInvoice.invoiceFormat.iDPrefix1'),
      value: false,
    },
    {
      label: getI18n('salesChannelInvoice.invoiceFormat.iDPrefix2'),
      value: true,
    },
  ];
  const IDSuffix = [
    {
      label: getI18n('salesChannelInvoice.invoiceFormat.iDSuffix1'),
      value: false,
    },
    {
      label: getI18n('salesChannelInvoice.invoiceFormat.iDSuffix2'),
      value: true,
    },
  ];
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.invoiceFormat}
      title={getI18n('salesChannelInvoice.invoiceFormat.invoiceIDFormat')}
      subtitle={getI18n(
        'salesChannelInvoice.invoiceFormat.invoiceIDFormatSubtitle',
      )}>
      <Row
        elements={[
          {
            child: (
              <Fragment>
                <Form.Item name='prefixCustomized'>
                  <Radio
                    className={css.informationCustomized}
                    radioList={IDPrefix}
                    disabled={disableEdit}></Radio>
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.prefixCustomized !==
                    currentValues.prefixCustomized
                  }>
                  {({ getFieldValue }) => (
                    <Form.Item
                      name={
                        getFieldValue('prefixCustomized')
                          ? 'prefixCustomizedText'
                          : 'prefix'
                      }
                      rules={[
                        {
                          pattern: /^[0-9a-zA-Z-]{1,}$/,
                          message: getI18n('general.invalidformat'),
                        },
                      ]}>
                      <Input
                        disabled={
                          !getFieldValue('prefixCustomized') || disableEdit
                        }
                        size='large'
                        className={css.input}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              </Fragment>
            ),
          },
          {
            child: (
              <Fragment>
                <Form.Item name='suffixCustomized'>
                  <Radio
                    className={css.informationCustomized}
                    radioList={IDSuffix}
                    disabled={disableEdit}></Radio>
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.suffixCustomized !==
                    currentValues.suffixCustomized
                  }>
                  {({ getFieldValue }) => (
                    <Form.Item
                      name={
                        getFieldValue('suffixCustomized')
                          ? 'suffixCustomizedText'
                          : 'suffix'
                      }
                      rules={[
                        {
                          pattern: /^[0-9a-zA-Z-]{1,}$/,
                          message: getI18n('general.invalidformat'),
                        },
                      ]}>
                      <Input
                        disabled={
                          !getFieldValue('suffixCustomized') || disableEdit
                        }
                        size='large'
                        className={css.input}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              </Fragment>
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};

export default InvoiceFormat;
